import React from "react";
import { AuthenticationProvider } from "./contexts/AuthenticationContext";
import { WorkspaceProvider } from "./contexts/WorkspaceContext";
import { GraphqlClientProvider } from "./contexts/GraphqlClient";

function AppContextProviders({ children }) {
  return (
    <AuthenticationProvider>
      <GraphqlClientProvider>
        <WorkspaceProvider>{children}</WorkspaceProvider>
      </GraphqlClientProvider>
    </AuthenticationProvider>
  );
}

export default AppContextProviders;
